var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconFileAudio = function SvgIconFileAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4F63FF",
    d: "M20.343 0a6 6 0 0 1 4.243 1.757l9.657 9.657A6 6 0 0 1 36 15.657V36a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8Zm0 2H8a6 6 0 0 0-6 6v28a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V15.657a4 4 0 0 0-1.172-2.829l-9.656-9.656A4 4 0 0 0 20.343 2Zm3.648 13c1.107 0 2.009.896 2.009 2V27.54a3.5 3.5 0 1 1-2-3.202V19h-8v8.585h-.001A3.5 3.5 0 1 1 14 24.336v-7.328c0-1.107.9-2.009 2.009-2.009h7.982ZM12.5 26a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm10 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
  })));
};

export default SvgIconFileAudio;